<template>
  <div class="c-base-card-color" :style="colors">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    colors: {
      type: Object,
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-card-color {
  width: 100%;
  padding: 1.4em;
  border-radius: 4px;
  border: solid 1px;
  margin-bottom: 1.5em;
  background-color: #f5fdfe;
  border-color: #aedfe6;
}
</style>
